export default __webpack_public_path__ + "static/media/seniorCitizenGraph-3.00cb20d5.jpeg";